/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Recentlyedited1Inputs */



/**

* @param {_Wiki_Recentlyedited1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_recentlyedited1 = /** @type {((inputs?: _Wiki_Recentlyedited1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Recentlyedited1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Zuletzt bearbeitet")
});
export { _wiki_recentlyedited1 as "_wiki_recentlyEdited" }